// © 2025 Ananda Kumar. All rights reserved.
// Unauthorized copying of this file, via any medium, is strictly prohibited.

/**
 * User Roles - Enumeration for type-safe role checking
 */
export enum UserRole {
  Admin = 'admin',
  LoggedInUser = 'loggedinuser'
}

/**
 * PIN Verification Request Model
 * Used for POST /api/pin/verify endpoint
 */
export interface VerifyPinRequest {
  appConfigurationId: string;
  menuKey: string;
  groupKey?: string;
  pin: string;
}

/**
 * PIN Verification Response Model
 * Returns expiration time of the authenticated session
 */
export interface VerifyPinResponse {
  expiresAt: string; // ISO datetime string
}

/**
 * Current User Response Model
 * Returned from GET /api/auth/me endpoint
 */
export interface CurrentUserResponse {
  isAuthenticated: boolean;
  userId: string; // User email or username
  displayName: string;
  roles: string[];
  authorizedMenus: string[];
  tenantId: string;
}

/**
 * Generic API Response Wrapper
 * Wraps all API responses from backend
 */
export interface ApiResponse<T> {
  success: boolean;
  value?: T;
  errors: string[];
}

/**
 * Local Authentication State
 * Managed by AuthService using BehaviorSubject
 * Tracks current user and authentication status
 */
export interface AuthState {
  isAuthenticated: boolean;
  user: CurrentUserResponse | null;
  loading: boolean;
  error: string | null;
  tenantId: string;
}
